import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transaction } from '@fry/payments/lib';

@Component({
    selector: 'eas-payments-error',
    templateUrl: './transaction.error.component.html',
    standalone: false
})
export class TransactionErrorComponent {

    @Input() transaction!: Transaction;
    @Input() error: Error;
    @Output() retry = new EventEmitter<void>();

    constructor() { }

    onRetry() {
        this.retry.emit();
    }
}
